import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import {
  type CardDisplayStatusEnum,
  CardDisplayStatuses,
} from '../../entities/enums/CardDisplayStatusEnum'

export const useFormatCardStatusLabel = () => {
  const intl = useProcurifyIntl()

  return (status: CardDisplayStatusEnum) => {
    switch (status) {
      case CardDisplayStatuses.ACTIVE:
        return intl.formatMessage(messages.activeLabel)
      case CardDisplayStatuses.PENDING:
        return intl.formatMessage(messages.pendingLabel)
      case CardDisplayStatuses.LOCKED:
        return intl.formatMessage(messages.lockedLabel)
      case CardDisplayStatuses.CANCELED:
        return intl.formatMessage(messages.canceledLabel)
      default:
        return ''
    }
  }
}
